module.exports = __webpack_public_path__ + "static/media/george-loading.9d62ad89.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/george-loading.svg
// module id = 721
// module chunks = 21